module.exports = __webpack_public_path__ + "img/ak.b21ce031.svg";